// extracted by mini-css-extract-plugin
export default {"button":"RibbonButton_button__a1zhb","disabled":"RibbonButton_disabled__7NEYi"};